// extracted by mini-css-extract-plugin
export default {"anim":"HomeCarousel_anim__3cw34","ShowSlide":"HomeCarousel_ShowSlide__Ln1nm"};